import React, {useState,useEffect,useContext} from 'react';
import { portfolioContext } from '../section/PortfolioWithLnb';



const PortfolioLnb = () => {

  const [lnbList, setLnbList] = useState([]);
  const {nowLnb,handleLnbClicked, lnb} = useContext(portfolioContext);

  useEffect(()=> {
    setLnbList(lnb);
    if(lnb[0]!=='all'){
      setLnbList(['all', ...lnb]);
    }
  }, [lnb])

  return (
    <div className="PortfolioLnb">

      <div className="con">
        <ul className="wrap-portfolio-lnb">
          {lnbList.map((el,index) => {
            return <li onClick={()=> {handleLnbClicked(el)}} key = {index} className={nowLnb.toLowerCase()===el.toLowerCase() ? `lnb-active` : ""}>{el}</li>
          })}
        </ul>
      </div>
    </div>
  );
}

export default PortfolioLnb;